const DelProj = props => (
  <div className="modal fade" id="delproj" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="delproj" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">Projekt löschen</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body">
          Möchtest du das Projekt <b>{props.name}</b> mit allen Daten wirklich löschen?
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Abbrechen</button>
          <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={props.DeleteProject}>Projekt löschen</button>
        </div>
      </div>
    </div>
  </div>
)
export default DelProj;